export default "__VITE_ASSET__c91639eb__"